import { render, staticRenderFns } from "./BoardDetail.vue?vue&type=template&id=855c2fba&scoped=true"
import script from "./BoardDetail.vue?vue&type=script&lang=js"
export * from "./BoardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855c2fba",
  null
  
)

export default component.exports